import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Network, ArrowRight } from "lucide-react";
import { getTranslatedModuleSlug } from "@/utils/routing";

const COPY = {
  sk: {
    title: "Pripravení na e-faktúru cez Peppol — už teraz",
    subtitle:
      "Bidmio vystavuje a prijíma elektronické faktúry v EN 16931 a doručuje ich cez sieť Peppol. Poháňané epostak Enterprise API.",
    cta: "Zistiť viac",
  },
  cs: {
    title: "Připraveni na e-fakturu přes Peppol — už teď",
    subtitle:
      "Bidmio vystavuje a přijímá elektronické faktury v EN 16931 a doručuje je přes síť Peppol. Poháněno epostak Enterprise API.",
    cta: "Zjistit více",
  },
};

const EInvoiceHomeBanner = () => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "sk") as string;

  if (lang !== "sk" && lang !== "cs") return null;
  const copy = COPY[lang as "sk" | "cs"];
  const href = `/moduly/${getTranslatedModuleSlug("online-fakturacia", lang as "sk" | "cs")}/`;

  return (
    <section className="bg-background" data-testid="banner-einvoice-home">
      <div className="container-custom py-6">
        <Link to={href} className="block group">
          <div className="glass-card rounded-xl border border-primary/30 bg-gradient-to-r from-primary/5 via-background to-accent/5 p-5 md:p-6 hover:border-primary/60 transition-colors">
            <div className="flex flex-col md:flex-row md:items-center gap-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 shrink-0">
                <Network className="h-6 w-6 text-primary" />
              </div>
              <div className="flex-1">
                <h2 className="font-semibold text-foreground group-hover:text-primary transition-colors">
                  {copy.title}
                </h2>
                <p className="text-sm text-muted-foreground mt-1">{copy.subtitle}</p>
              </div>
              <span className="inline-flex items-center gap-1 text-primary font-medium text-sm whitespace-nowrap">
                {copy.cta}
                <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default EInvoiceHomeBanner;
